import AgentActivity from 'models/agent_activity';
import { AgentAvailability } from 'models/agent_status';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';

export default class UpdatePresence {
  constructor(context) {
    this.context = context;
  }

  run() {
    let agentStatus = this.context.stores.agentStatus.get();
    if (
      agentStatus &&
      agentStatus.getAvailability() !== AgentAvailability.OFFLINE &&
      agentStatus.getAvailability() !== AgentAvailability.AWAY
    ) {
      this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.PRESENCE });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/agent_activity/update_presence.js